/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Standard_HighlightInputs */

const et_plan_standard_highlight = /** @type {(inputs: Plan_Standard_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nähtav 60% tulemustest.`)
};

const en_plan_standard_highlight = /** @type {(inputs: Plan_Standard_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible in 60% of results.`)
};

/**
* | output |
* | --- |
* | "Visible in 60% of results." |
*
* @param {Plan_Standard_HighlightInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_standard_highlight = /** @type {((inputs?: Plan_Standard_HighlightInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Standard_HighlightInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_standard_highlight(inputs)
	return en_plan_standard_highlight(inputs)
});